import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface Notification {
  id: string;
  [key: string]: any;
}

export interface NotificationsState {
  listLoading: boolean;
  actionsLoading: boolean;
  totalCount: number;
  pageCount: number;
  entities: Notification[] | null;
  error: string | null;
}

export interface NotificationsPayload {
  totalCount: number;
  pageCount: number;
  entities: Notification[];
}

export const callTypes = {
  list: "list",
  action: "action",
} as const;


const initialNotificationsState: NotificationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: initialNotificationsState,
  reducers: {
    notificationsFetched: (
      state,
      action: PayloadAction<NotificationsPayload>
    ) => {
      const { totalCount, pageCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    notificationsAppended: (
      state,
      action: PayloadAction<NotificationsPayload>
    ) => {
      const { totalCount, pageCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities
        ? [...state.entities, ...entities]
        : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    catchError: (
      state,
      action: PayloadAction<{ error: string; callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (
      state,
      action: PayloadAction<{ callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  },
});

export const { notificationsFetched, notificationsAppended, catchError, startCall } = notificationsSlice.actions;